import { createFileRoute } from '@tanstack/react-router'
import { McpAccessScreen } from '@/features/mcp/routes/mcp-access-screen'

// The header and the tab title come from the address (nav-config.ts).
export const Route = createFileRoute('/settings/mcp')({ component: McpAccessScreen })
